import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=328dcdc6&"
import script from "./Verified.vue?vue&type=script&lang=js&"
export * from "./Verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Verified.vue"
export default component.exports